// Brand artwork, not icons: the providers' marks keep their own colours, as their sign-in branding asks
// (design/DESIGN.md, theme exceptions). Google's "G" is its official mark (Google's 48dp logo_googleg, gstatic),
// Strava's the prototype's. The same artwork as the watch screen's sign-in sheet (components/watch/SignInSheet.tsx).

export function GoogleMark() {
  return (
    <svg viewBox="0 0 120 120" aria-hidden="true" focusable="false">
      <path fill="#4285F4" d="M117.6 61.364c0-4.255-.382-8.346-1.091-12.273H60V72.3h32.291c-1.391 7.5-5.618 13.855-11.973 18.11v15.054h19.391c11.346-10.446 17.891-25.828 17.891-44.1z" />
      <path fill="#34A853" d="M60 120c16.2 0 29.782-5.373 39.709-14.536L80.318 90.41C74.945 94.009 68.073 96.136 60 96.136c-15.627 0-28.855-10.554-33.573-24.736H6.382v15.545C16.255 106.555 36.545 120 60 120z" />
      <path fill="#FBBC05" d="M26.427 71.4c-1.2-3.6-1.882-7.445-1.882-11.4s.682-7.8 1.882-11.4V33.055H6.382C2.318 41.155 0 50.318 0 60s2.318 18.845 6.382 26.945L26.427 71.4z" />
      <path fill="#EA4335" d="M60 23.864c8.809 0 16.718 3.027 22.936 8.972l17.21-17.209C89.754 5.945 76.172 0 60 0 36.545 0 16.255 13.445 6.382 33.055L26.427 48.6C31.145 34.418 44.373 23.864 60 23.864z" />
    </svg>
  )
}

export function StravaMark() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="#FC4C02" d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169" />
    </svg>
  )
}
